import { render, staticRenderFns } from "./AsHistoryListItem.vue?vue&type=template&id=1049e474&scoped=true"
import script from "./AsHistoryListItem.vue?vue&type=script&lang=js"
export * from "./AsHistoryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049e474",
  null
  
)

export default component.exports